export const UAPImageExpansionType = {
  None: 'None',
  WhitePadding: 'WhitePadding',
  // Blur: 'Blur',
  Outpainting: 'Outpainting',
  SingleColorPadding: 'SingleColorPadding',
};

export const UAPCroppingType = {
  ManualCrop: 'ManualCrop', // 1
  CenterCrop: 'CenterCrop', // 2
  SmartCrop: 'SmartCrop', // 3
  Unknown: 'Unknown', // 4
};
